import React from "react";
import DashboardMenuContent from "../../../../components/menus/DashboardMenu/DashboardMenuContent";
import {useConsumerMenu} from "../context/MenuContext";

const PostPlanOptions = () => {
  const {handleClose} = useConsumerMenu();

  return <DashboardMenuContent onClose={handleClose} hasDivider />;
};

export default PostPlanOptions;
